<empusa-core-spinner *ngIf="loading" [overlay]="true"></empusa-core-spinner>

<mat-drawer-container class="container" [hasBackdrop]="false">
  <mat-drawer #drawer [mode]="'side'" class="side-menu-back">
    <div class="head-drawer-title">
      <mat-icon class="back" (click)="drawer.toggle()">keyboard_backspace</mat-icon>
      <div class="logo-left"></div>
      <div *ngIf="site" class="site">{{site}}</div>
    </div>
    <nav class="side-menu-nav">
      <ul>
        <li *ngFor="let module of modules; let i = index" routerLinkActive="active" [routerLink]="['/'+ module.path]"
          class="animated fadeInUp delay1">
          <a class="side-menu-options">
            <mat-icon>{{module.icon}}</mat-icon>
            <span>{{'MENU.' + module.name.toUpperCase() | translate}}</span>
          </a>
          <mat-icon class="arrow_box">keyboard_arrow_right</mat-icon>
        </li>
        <li *ngIf="includeGrafana" class="animated fadeInUp delay1">
          <a class="side-menu-options" href="{{bmsGrafana}}" target="_blank">
            <mat-icon>trending_up</mat-icon>
            <span>Dashboards</span>
          </a>
        </li>
      </ul>
    </nav>
    <div class="terms-and-privacy">
      <a mat-button href="{{privacyPolicyUrl}}" target="_blank" *ngIf="privacyPolicyUrl">{{'MENU.PRIVACY_POLICY' |
        translate}}</a>
      <button mat-button *ngIf="termsOfUse" (click)="openTermsOfUse()">{{'MENU.TERMS_OF_USE' |
        translate}}</button>
    </div>
    <div class="divider"></div>
    <span class="copyright">© 2022 Getronics - Smart Spaces</span>
  </mat-drawer>

  <mat-drawer-content>
    <div class="horizontal-apli-menu horizontal-menu">
      <!-- CABECERA CON MENÚ -->
      <div class="header">
        <div class="header-inner">
          <button class="navbar-toggler custom-toggler" type="button" data-toggle="collapse"
            [attr.data-target]="navbarTarget" aria-controls="navbarSupportedContent" aria-expanded="false"
            aria-label="Toggle navigation"> <span class="navbar-toggler-icon"></span></button>
          <h1 class="logo-name cursor-hand" (click)="goInitialPage();">
            <img src="../assets/images/logo-envalora.svg" height="24" class="d-inline-block align-middle"
              alt="Getronics" />
            <span class="line-vert"></span>
            <div class="name-apli d-inline-block align-middle font-weight-normal">ENVANET</div>
          </h1>
          <div class="float-com-user">
            <div class="text-center align-middle cont-user">
              <div class="cont-mail" (click)="openComunications()">
                <div *ngIf="comunicacionesPendientes" class="number-msg">{{comunicacionesPendientes}}</div>
                <div class="mail-icon">
                  <mat-icon style="transform: scale(1.7);">mail</mat-icon>
                </div>
              </div>
              <div class="nav">
                <div class="nav-item dropdown">
                  <a class="nav-link p-0 dropdown-toggle dropdown-toggle-user" data-toggle="dropdown" href="#"
                    role="button" aria-haspopup="true" aria-expanded="false"><span class="icon-user"></span></a>
                  <div class="dropdown-menu dropdown-menu-user text-center bs-popover-bottom p-4"
                    x-placement="bottom-start">
                    <div class="dropdown-item user-dropdown-item">
                      <span class="icon-user"></span>
                      <div class="datos-user">{{ authService.user?.givenName }}</div>
                      <button type="button" class="btn btn-secondary" (click)="logout()">Salir</button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="container">
          <!-- Menú principal de navegación -->
          <nav class="navbar navbar-expand-xl d-block">
            <div
              class="navbar-collapse justify-content-md-center justify-content-between justify-content-center justify-content-lg-center justify-content-xl-center justify-content-sm-center collapse"
              id="navbarSupportedContent">
              <ul class="navbar-nav">
                <li *ngIf="canAccessAdministration()" class="nav-item dropdown menu-down">
                  <a class="nav-link dropdown-toggle mr-lg-2" href="#" id="navbarDropdown1" role="button"
                    data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">Administración</a>
                  <div class="dropdown-menu" aria-labelledby="navbarDropdown1">
                    <div class="dropdown-item-title text-primary">Administración</div>
                    <a class="dropdown-item" data-toggle="collapse" [attr.data-target]="navbarTarget"
                      [routerLink]="['administration', 'users', 'search']">Usuarios</a>
                    <a class="dropdown-item" data-toggle="collapse" [attr.data-target]="navbarTarget"
                      [routerLink]="['administration', 'rates', 'search']">Tarifas un solo uso</a>
                    <a class="dropdown-item" data-toggle="collapse" [attr.data-target]="navbarTarget"
                      [routerLink]="['administration', 'closedRates', 'search']">Tarifas envases SDDR cerrado</a>
                    <a class="dropdown-item" data-toggle="collapse" [attr.data-target]="navbarTarget"
                      [routerLink]="['administration', 'ratesOpen', 'search']">Tarifas envases SDDR abierto</a>
                    <a class="dropdown-item" data-toggle="collapse" [attr.data-target]="navbarTarget"
                      [routerLink]="['administration', 'ratesPackagingSystem', 'search']">TARIFAS ENVASES SDDR ABIERTO SIN GOBERNANZA</a>                    <a class="dropdown-item" data-toggle="collapse" [attr.data-target]="navbarTarget"
                      [routerLink]="['administration', 'ratesHolders', 'search']">Tarifas Poseedores</a>
                    <a class="dropdown-item" data-toggle="collapse" [attr.data-target]="navbarTarget"
                      [routerLink]="['administration', 'ratesCollectionPoint', 'search']">Tarifas Puntos Recogida</a>
                    <a class="dropdown-item" data-toggle="collapse" [attr.data-target]="navbarTarget"
                      [routerLink]="['administration', 'ratesSddrCa', 'search']">Tarifas SDDR Abierto</a>
                    <a class="dropdown-item" data-toggle="collapse" [attr.data-target]="navbarTarget"
                      [routerLink]="['administration', 'ratesManagerAgreements', 'search']">Tarifas Acuerdo Indirecto</a>
                    <a class="dropdown-item" data-toggle="collapse" [attr.data-target]="navbarTarget"
                      [routerLink]="['administration', 'templates', 'list']">Plantillas de documentos</a>
                    <a class="dropdown-item" data-toggle="collapse" [attr.data-target]="navbarTarget"
                      [routerLink]="['administration', 'mail-templates', 'list']">Plantillas de correos</a>
                    <a class="dropdown-item" data-toggle="collapse" [attr.data-target]="navbarTarget"
                        [routerLink]="['administration', 'pre-invoicing', 'generate']">Prefacturación</a>
                    <a class="dropdown-item" data-toggle="collapse" [attr.data-target]="navbarTarget"
                        [routerLink]="['administration', 'documentInterest', 'search']">Documentos de interés</a>
                    <a class="dropdown-item" data-toggle="collapse" [attr.data-target]="navbarTarget"
                      [routerLink]="['administration', 'notification', 'search']">Configuración notificaciones</a>
                    <a class="dropdown-item" data-toggle="collapse" [attr.data-target]="navbarTarget"
                      [routerLink]="['administration', 'declarationCampaign', 'search']">Campañas</a>
                    <a class="dropdown-item" data-toggle="collapse" [attr.data-target]="navbarTarget"
                      [routerLink]="['administration', 'replications', 'search']">Replicaciones</a>
                  </div>
                </li>
                <li *ngIf="this.canViewMenu('AD-ADHERIDO')
                  || this.canViewMenu('DE-ENV-GEST')
                  || this.canViewMenu('AD-ENV-CONS')
                  || this.canViewMenu('DE-ADHERIDO')"
                    class="nav-item dropdown menu-down">
                  <a class="nav-link dropdown-toggle mr-lg-2" href="#" id="navbarDropdown2" role="button"
                     data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">Adheridos</a>
                  <div class="dropdown-menu" aria-labelledby="navbarDropdown2">
                    <div class="dropdown-item-title text-primary">Adheridos</div>
                    <a *ngIf="canAccessAttachedAppSearch()" class="dropdown-item" data-toggle="collapse"
                      [attr.data-target]="navbarTarget" [routerLink]="['attached-app', 'search']">Búsqueda de
                      Adheridos</a>
                    <!-- <a *ngIf="entityRoles && entityRoles.length > 0" class="dropdown-item" [href]="'#/attached-app/detail/'+viewMyData">Mis
                      Datos</a> -->
                    <!-- <ng-container *ngIf="entityRoles && entityRoles.length > 0">
                      <ng-container *ngFor="let adheridoRol of adheridosRoles">
                        <a *ngIf="adheridoRol?.entity && adheridoRol?.entityObject" class="dropdown-item"
                          data-toggle="collapse" [attr.data-target]="navbarTarget"
                          (click)="redirectTo('/attached-app/detail/' + adheridoRol?.entity)">
                          Mis Datos - {{ adheridoRol.entityObject?.razonSocial }}
                        </a>
                      </ng-container>
                    </ng-container>-->
                    <ng-container *ngIf="entityRoles && entityRoles.length > 0">
                      <ng-container *ngFor="let adheridoRol of adheridosRoles">
                        <ng-container *ngIf="adheridoRol?.entity && adheridoRol?.entityObject && adheridoRol?.entityObject.length > 0">
                          <ng-container *ngFor="let adheridoRolEntObj of adheridoRol.entityObject">
                            <a class="dropdown-item"
                              data-toggle="collapse" [attr.data-target]="navbarTarget"
                              (click)="redirectTo('/attached-app/detail/' + adheridoRolEntObj?.id)">
                              Mis Datos - {{ adheridoRolEntObj?.razonSocial }}
                            </a>
                          </ng-container>
                        </ng-container>
                      </ng-container>
                    </ng-container>
                    <a *ngIf="canAccessPackagingDeclaration()" class="dropdown-item" data-toggle="collapse"
                      [attr.data-target]="navbarTarget" [routerLink]="['attached-app', 'packaging-declaration-search']">
                      Declaración de envases</a>
                  </div>
                </li>
                <li *ngIf="canAccessPoseedoresAppMenu()" class="nav-item dropdown menu-down">
                  <a class="nav-link dropdown-toggle mr-lg-2" href="#" id="navbarDropdown3" role="button"
                    data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">Poseedores Finales</a>
                  <div class="dropdown-menu" aria-labelledby="navbarDropdown3">
                    <div class="dropdown-item-title text-primary">Poseedores Finales</div>
                    <!--<ng-container *ngIf="entityRoles && entityRoles.length > 0">
                      <ng-container *ngFor="let poseedorRoles of poseedoresRoles">
                        <a *ngIf="poseedorRoles?.entity && poseedorRoles?.entityObject" class="dropdown-item"
                          data-toggle="collapse" [attr.data-target]="navbarTarget"
                          (click)="redirectTo('/holders/detail/' + poseedorRoles?.entity)">
                          Mis Datos - {{ poseedorRoles.entityObject?.razonSocial }} - {{ poseedorRoles.entityObject?.denominacionCentro }}
                        </a>
                      </ng-container>
                    </ng-container>-->
                    <ng-container *ngIf="entityRoles && entityRoles.length > 0">
                      <ng-container *ngFor="let poseedorRoles of poseedoresRoles">
                        <ng-container *ngIf="poseedorRoles?.entity && poseedorRoles?.entityObject && poseedorRoles?.entityObject.length > 0">
                          <ng-container *ngFor="let poseedorRolEntObj of poseedorRoles.entityObject">
                            <a class="dropdown-item"
                              data-toggle="collapse" [attr.data-target]="navbarTarget"
                              (click)="redirectTo('/holders/detail/' + poseedorRolEntObj?.id)">
                              Mis Datos - {{ poseedorRolEntObj?.razonSocial }} - {{ poseedorRolEntObj?.denominacionCentro }}
                            </a>
                          </ng-container>
                        </ng-container>
                      </ng-container>
                    </ng-container>
                    <!--<ng-container *ngIf="entityRoles && entityRoles.length > 0">
                      <ng-container *ngFor="let gestorRoles of gestoresRoles">
                        <a *ngIf="gestorRoles?.entity && gestorRoles?.entityObject" class="dropdown-item"
                          data-toggle="collapse" [attr.data-target]="navbarTarget"
                          (click)="redirectTo('/holders/waste-managers-detail/' + gestorRoles?.entity)">
                          Mis Datos - {{ gestorRoles.entityObject?.razonSocial }} - {{ gestorRoles.entityObject?.centro }}
                        </a>
                      </ng-container>
                    </ng-container>-->
                    <ng-container *ngIf="entityRoles && entityRoles.length > 0">
                      <ng-container *ngFor="let gestorRoles of gestoresRoles">
                        <ng-container *ngIf="gestorRoles?.entity && gestorRoles?.entityObject && gestorRoles?.entityObject.length > 0">
                          <ng-container *ngFor="let gestorRolEntObj of gestorRoles.entityObject">
                            <a class="dropdown-item"
                              data-toggle="collapse" [attr.data-target]="navbarTarget"
                              (click)="redirectTo('/holders/waste-managers-detail/' + gestorRolEntObj?.id)">
                              Mis Datos - {{ gestorRolEntObj?.razonSocial }} - {{ gestorRolEntObj?.centro }}
                            </a>
                          </ng-container>
                        </ng-container>
                      </ng-container>
                    </ng-container>
                    <a class="dropdown-item" *ngIf="canAccessPoseedoresSearchAccess()" data-toggle="collapse"
                      [attr.data-target]="navbarTarget" [routerLink]="['holders', 'search']">Búsqueda
                      de
                      poseedores</a>
                    <a class="dropdown-item" *ngIf="canAccessPoseedoresGestorSearchAccess()" data-toggle="collapse"
                      [attr.data-target]="navbarTarget" [routerLink]="['holders', 'waste-managers-search']">Búsqueda
                      de gestores/acondicionadores</a>
                    <a *ngIf="canAccessPoseedoresDiSearchAccess() && !canViewMenu('PO-POSEEDOR') && !canViewMenu('PO-GESTOR')" class="dropdown-item" data-toggle="collapse"
                      [attr.data-target]="navbarTarget"
                      [routerLink]="['holders', 'contributions-dis-search']">Aportaciones de DI/FS</a>
                    <a *ngIf="canViewMenu('PO-POSEEDOR')" class="dropdown-item" data-toggle="collapse"
                      [attr.data-target]="navbarTarget"
                      [routerLink]="['holders', 'contributions-dis-search']" [queryParams]="{tipo: 'poseedor'}">Aportaciones de DI/FS Poseedores</a>
                    <a *ngIf="canViewMenu('PO-GESTOR')" class="dropdown-item" data-toggle="collapse"
                      [attr.data-target]="navbarTarget"
                      [routerLink]="['holders', 'contributions-dis-search']" [queryParams]="{tipo: 'gestor'}">Aportaciones de DI/FS Gestores</a>
                    <a *ngIf="canAccessPoseedoresAutoFacturaSearchAccess()" class="dropdown-item" data-toggle="collapse"
                      [attr.data-target]="navbarTarget" [routerLink]="['holders', 'invoices-search']">Prefacturas y
                      facturas</a>
                  </div>
                </li>
                <li *ngIf="canAccessCollectionPoints()"
                  class="nav-item dropdown menu-down">
                  <a class="nav-link dropdown-toggle mr-lg-2" href="#" id="navbarDropdown6" role="button"
                    data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">Puntos de recogida</a>

                  <div class="dropdown-menu" aria-labelledby="navbarDropdown6">
                    <div class="dropdown-item-title text-primary">Puntos de recogida </div>

                    <!--<ng-container *ngIf="entityRoles && entityRoles.length > 0">
                      <ng-container *ngFor="let ptoRoles of puntosRecogidaRoles">
                        <a *ngIf="ptoRoles?.entity && ptoRoles?.entityObject" class="dropdown-item"
                          data-toggle="collapse" [attr.data-target]="navbarTarget"
                          (click)="redirectTo('/collection-points/detail/' + ptoRoles?.entity)">
                          Mis Datos - {{ ptoRoles.entityObject?.razonSocial }}
                        </a>
                      </ng-container>
                    </ng-container>-->
                    <ng-container *ngIf="entityRoles && entityRoles.length > 0">
                      <ng-container *ngFor="let ptoRoles of puntosRecogidaRoles">
                        <ng-container *ngIf="ptoRoles?.entity && ptoRoles?.entityObject && ptoRoles?.entityObject.length > 0">
                          <ng-container *ngFor="let ptoRolEntObj of ptoRoles.entityObject">
                            <a class="dropdown-item"
                              data-toggle="collapse" [attr.data-target]="navbarTarget"
                              (click)="redirectTo('/collection-points/detail/' + ptoRolEntObj?.id)">
                              Mis Datos - {{ ptoRolEntObj?.razonSocial }}
                            </a>
                          </ng-container>
                        </ng-container>
                      </ng-container>
                    </ng-container>

                    <!--<ng-container *ngIf="entityRoles && entityRoles.length > 0">
                      <ng-container *ngFor="let gestorPtoRoles of gestorPuntosRecogidaRoles">
                        <a *ngIf="gestorPtoRoles?.entity && gestorPtoRoles?.entityObject" class="dropdown-item"
                          data-toggle="collapse" [attr.data-target]="navbarTarget"
                          (click)="redirectTo('/collection-points/manager-detail/' + gestorPtoRoles?.entity)">
                          Mis Datos - {{ gestorPtoRoles.entityObject?.razonSocial }}
                        </a>
                      </ng-container>
                    </ng-container>-->
                    <ng-container *ngIf="entityRoles && entityRoles.length > 0">
                      <ng-container *ngFor="let gestorPtoRoles of gestorPuntosRecogidaRoles">
                        <ng-container *ngIf="gestorPtoRoles?.entity && gestorPtoRoles?.entityObject && gestorPtoRoles?.entityObject.length > 0">
                          <ng-container *ngFor="let gestorPtoRolEntObj of gestorPtoRoles.entityObject">
                            <a class="dropdown-item"
                              data-toggle="collapse" [attr.data-target]="navbarTarget"
                              (click)="redirectTo('/collection-points/manager-detail/' + gestorPtoRolEntObj?.id)">
                              Mis Datos - {{ gestorPtoRolEntObj?.razonSocial }}
                            </a>
                          </ng-container>
                        </ng-container>
                      </ng-container>
                    </ng-container>

                    <a class="dropdown-item" *ngIf="canAccessCollectionPointsSearch()" data-toggle="collapse"
                      [attr.data-target]="navbarTarget" [routerLink]="['collection-points', 'search']">Búsqueda de
                      puntos de recogida</a>
                    <a class="dropdown-item" *ngIf="canAccessCollectionPointsManagerSearch()" data-toggle="collapse"
                      [attr.data-target]="navbarTarget" [routerLink]="['collection-points', 'manager-search']">Búsqueda
                      de gestores de puntos de
                      recogida</a>
                    <a class="dropdown-item" *ngIf="canAccessCollectionPointsRequestsSearch()" data-toggle="collapse"
                      [attr.data-target]="navbarTarget" [routerLink]="['collection-points',
                      'requests-search']">
                      <ng-container
                        *ngIf="canViewMenu('PR-ENV-GEST') || canViewMenu('PR-ENV-CONS'); else misSolicitudes">
                        Búsqueda de solicitudes
                      </ng-container>
                      <ng-template #misSolicitudes>
                        Mis solicitudes
                      </ng-template>
                    </a>
                    <a class="dropdown-item" *ngIf="canAccessCPSelfInvoicesRequestsSearch()" data-toggle="collapse"
                      [attr.data-target]="navbarTarget"
                      [routerLink]="['collection-points', 'cp-invoices-search']">Prefacturas y
                      facturas</a>
                  </div>
                </li>
                <li *ngIf="canAccessOpenSddrModule()"
                    class="nav-item dropdown menu-down">
                  <a class="nav-link dropdown-toggle mr-lg-2" href="#" id="navbarDropdown8" role="button"
                     data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">SDDR Abierto</a>
                  <div class="dropdown-menu" aria-labelledby="navbarDropdown8">
                    <div class="dropdown-item-title text-primary">SDDR Abierto</div>
                    <a *ngIf="canAccessOpenSddrReuseRequest()" class="dropdown-item" data-toggle="collapse"
                      [attr.data-target]="navbarTarget" [routerLink]="['open-sddr', 'reuse-search']">Solicitudes de
                      reutilización</a>
                    <a *ngIf="canAccessOpenSddrWithDrawnRequest()" class="dropdown-item" data-toggle="collapse"
                      [attr.data-target]="navbarTarget"
                      [routerLink]="['open-sddr', 'requests-withdrawn-search']">Solicitudes de retirada</a>
                    <a *ngIf="canAccessOpenSddrRemainRequest()" class="dropdown-item" data-toggle="collapse"
                      [attr.data-target]="navbarTarget"
                      [routerLink]="['open-sddr', 'requests-remain-search']">Solicitudes de envase SDDR Abierto</a>
                    <a *ngIf="canAccessOpenSddrDiSearch()" class="dropdown-item" data-toggle="collapse" [attr.data-target]="navbarTarget"
                      [routerLink]="['open-sddr', 'contributions-dis-search']">Aportaciones DI/FS</a>
                    <a *ngIf="canAccessOpenSddrAutofacturas()" class="dropdown-item" data-toggle="collapse" [attr.data-target]="navbarTarget"
                      [routerLink]="['open-sddr', 'invoices-search']">Prefacturas y facturas</a>
                  </div>
                </li>
                <li *ngIf="canAccessAdheridosDiSearchAccess()" class="nav-item dropdown menu-down">
                  <a class="nav-link dropdown-toggle mr-lg-2" href="#" id="navbarDropdown4" role="button"
                    data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">SDDR Cerrado</a>
                  <div class="dropdown-menu" aria-labelledby="navbarDropdown4">
                    <div class="dropdown-item-title text-primary">SDDR Cerrado</div>
                    <a class="dropdown-item" data-toggle="collapse" [attr.data-target]="navbarTarget"
                      [routerLink]="['attached-app', 'contributions-dis-search']">Aportaciones de DI/FS</a>
                  </div>
                </li>
                <li *ngIf="this.canAccessAcuerdoGestores()" class="nav-item dropdown menu-down">
                  <a class="nav-link dropdown-toggle mr-lg-2" href="#" id="navbarDropdown8" role="button"
                    data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">Acuerdo Indirecto</a>
                  <div class="dropdown-menu" aria-labelledby="navbarDropdown8">
                    <div class="dropdown-item-title text-primary">Acuerdo Indirecto</div>
                    <a *ngIf="canViewMenu('AI-ENV-GEST') || canViewMenu('AI-ENV-CONS')"
                      class="dropdown-item" data-toggle="collapse" [attr.data-target]="navbarTarget"
                      [routerLink]="['managers-agreements', 'indirect-agreement-search']">Búsqueda de Acuerdos</a>
                    <ng-container *ngIf="entityRoles && entityRoles.length > 0 && canViewIndirectAgreementGestor()">
                      <ng-container *ngFor="let acuerdoRol of acuerdosIndirectosRoles">
                        <ng-container *ngIf="acuerdoRol?.entityObject && acuerdoRol?.entityObject.length > 0; else acuerdoPorId">
                          <ng-container *ngFor="let acuerdoRolEntObj of acuerdoRol.entityObject">
                            <a class="dropdown-item"
                              data-toggle="collapse" [attr.data-target]="navbarTarget"
                              (click)="goToIndirectAgreementDetail(acuerdoRolEntObj)">
                              Mis Datos - {{ acuerdoRolEntObj?.razonSocial }}
                            </a>
                          </ng-container>
                        </ng-container>
                        <ng-template #acuerdoPorId>
                          <ng-container *ngFor="let acuerdoId of getEntityIds(acuerdoRol?.entity)">
                            <a class="dropdown-item"
                              data-toggle="collapse" [attr.data-target]="navbarTarget"
                              (click)="goToIndirectAgreementDetailById(acuerdoId)">
                              Mis Datos - Acuerdo {{ acuerdoId }}
                            </a>
                          </ng-container>
                        </ng-template>
                      </ng-container>
                    </ng-container>
                    <!-- <a *ngIf="canViewMenu('AG-POSEEDOR') || canViewMenu('AI-ENV-CONS') || canViewMenu('AI-ENV-GEST') || canViewMenu('AI-GESTOR')"
                      class="dropdown-item" data-toggle="collapse" [attr.data-target]="navbarTarget"
                      [routerLink]="['managers-agreements', 'search']">Búsqueda Gestores con Acuerdo</a> -->
                    <a *ngIf="canViewIndirectAgreementGestorFacturas()"
                      class="dropdown-item" data-toggle="collapse" [attr.data-target]="navbarTarget"
                      [routerLink]="['managers-agreements', 'contributions-dis-search']">Aportaciones de DI/FS</a>
                    <a *ngIf="canViewIndirectAgreementGestorFacturas()"
                      class="dropdown-item" data-toggle="collapse" [attr.data-target]="navbarTarget"
                      [routerLink]="['managers-agreements', 'invoices-search']">Prefacturas y facturas</a>
                  </div>
                </li>
                <li *ngIf="this.canAccessGestoresRegistrados()" class="nav-item dropdown menu-down">
                  <a class="nav-link dropdown-toggle mr-lg-2" href="#" id="navbarDropdown9" role="button"
                     data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">Gestores/Acondicionadores Registrados</a>
                  <div class="dropdown-menu" aria-labelledby="navbarDropdown9">
                    <div class="dropdown-item-title text-primary">Gestores/Acondicionadores Registrados</div>
                    <a *ngIf="canViewMenu('PO-POSEEDOR') || canViewMenu('PO-ENV-CONS') || canViewMenu('PO-ENV-GEST')"
                       class="dropdown-item" data-toggle="collapse" [attr.data-target]="navbarTarget"
                       [routerLink]="['holders', 'managers-registered-search']">Búsqueda Gestores/Acondicionadores Registrados</a>
                  </div>
                </li>
                <li *ngIf="this.canAccessCVFAppMenu()" class="nav-item dropdown menu-down">
                  <a class="nav-link dropdown-toggle mr-lg-2" href="#" id="navbarDropdown9" role="button"
                     data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">Cert. Valorización Final</a>
                  <div class="dropdown-menu" aria-labelledby="navbarDropdown9">
                    <div class="dropdown-item-title text-primary">Cert. Valorización Final</div>
                    <a *ngIf="canViewMenu('PO-ENV-CONS') || canViewMenu('PO-ENV-GEST')"
                       class="dropdown-item" data-toggle="collapse" [attr.data-target]="navbarTarget"
                       (click)="goToCvfSearch(null)" style="cursor: pointer;">CVF</a>
                    <a *ngIf="this.visualizarCVFGestor()"
                       class="dropdown-item" data-toggle="collapse" [attr.data-target]="navbarTarget"
                       (click)="goToCvfSearch('gestor')" style="cursor: pointer;">CVF Gestor</a>
                    <a *ngIf="this.visualizarCVFPoseedor()"
                       class="dropdown-item" data-toggle="collapse" [attr.data-target]="navbarTarget"
                       (click)="goToCvfSearch('poseedor')" style="cursor: pointer;">CVF Poseedor</a>
                       <a *ngIf="canViewMenu('PO-GESTOR') || canViewMenu('PO-ENV-GEST')"
                       class="dropdown-item" data-toggle="collapse" [attr.data-target]="navbarTarget" [routerLink]="['holders', 'holders-cvf-invoices-search']">
                       Prefacturas y facturas</a>
                  </div>
                </li>
              </ul>
            </div>
          </nav>
          <!-- FIN Menú principal de navegación -->
        </div>
      </div>

      <!-- FIN CABECERA CON MENÚ -->
    </div>

    <div class="empusa-container">
      <router-outlet></router-outlet>
    </div>

    <div class="container-fluid">
      <div class="footer my-flo d-flex align-items-center justify-content-between">
        <div class="text-footer">ENVANET v1.1</div>
        <div class="text-right font-weight-normal text-footer"><span class="pr-2">© Copyright 2023</span>·<a href="#"
            class="px-2">Envalora</a>·<a href="https://envalora.es/aviso-legal/" class="px-2">Aviso Legal</a>·<a
            href="https://envalora.es/politica-privacidad/" class="px-2">Política de
            Privacidad</a>·<a href="#" class="px-2">Política de cookies</a></div>
      </div>
    </div>


  </mat-drawer-content>

</mat-drawer-container>

<ng-template #modalTemplate>
  
  <mat-dialog-content>
    <p>En la esquina superior derecha tiene a su disposición el buzón de comunicaciones con Envalora para todas las consultas relacionadas con la plataforma y/o las declaraciones de envases. Cualquier otra consulta puede dirigirla a contacto@envalora.es.</p>
  </mat-dialog-content>
  <mat-dialog-actions align="center" style="margin-bottom:9px;">
    <button type="button" class="btn btn-primary" mat-dialog-close (click)="buttonAceptarModal()">Aceptar</button>
  </mat-dialog-actions>
</ng-template>


<ng-template #modalNotifTemplate>
  <h3 mat-dialog-title>Notificación</h3>
  <mat-divider></mat-divider>
  <mat-dialog-content>
    <p>{{ mensajeNotificacion }}</p>
  </mat-dialog-content>
  <mat-dialog-actions align="center" style="margin-bottom:9px;">
    <button type="button" class="btn btn-primary" mat-dialog-close (click)="buttonAceptarModalNotificaciones()">Aceptar</button>
  </mat-dialog-actions>
</ng-template>
